import { render } from "./EditScoreboard.vue?vue&type=template&id=e45f8c24"
import script from "./EditScoreboard.vue?vue&type=script&lang=js"
export * from "./EditScoreboard.vue?vue&type=script&lang=js"

import "./EditScoreboard.vue?vue&type=style&index=0&id=e45f8c24&lang=scss"

import exportComponent from "C:\\Users\\stall\\Documents\\Projects\\Web Apps\\Small Projects\\gmscoreboard2021-primevue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__